<div *ngIf="loading" class="text-center">
  <p-progressSpinner></p-progressSpinner>
</div>

<div class="field grid">
  <label class="col-fixed"></label>

  <div class="mojo-admin-page panel data-table ">
    <p-table [value]="contactUsSubjects" dataKey="Uri" editMode="row" responsiveLayout="scroll">
      <ng-template pTemplate="header">
        <tr>
          <th>Subject</th>
          <th>Notify</th>
          <th>Individual/Backup Email(s)</th>
          <th style="width:8rem"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-subject let-editing="editing" let-ri="rowIndex">
        <tr [pEditableRow]="subject" [formGroup]="getForm(subject, ri)">
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="text" formControlName="subjectName" required>
              </ng-template>
              <ng-template pTemplate="output">
                {{subject.Subject}}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-dropdown [options]="notifyTypes" optionValue="Value" optionLabel="Label" appendTo="body"
                            formControlName="notifyType" [style]="{'width':'100%'}"></p-dropdown>
              </ng-template>
              <ng-template pTemplate="output">
                {{getNotificationLabel(subject.NotifyType)}}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-chips [allowDuplicate]="false"
                         #emailschips
                         separator=","
                         formControlName="emails"
                         [style]="{'width':'100%'}"
                         placeholder="Press enter after each email address"
                         required>
                </p-chips>
              </ng-template>
              <ng-template pTemplate="output">
                {{subject.Emails.join(', ')}}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <div *ngIf="!editing" class="flex flex-col">
              <button *ngIf="!editing" pButton icon="pi pi-pencil" pInitEditableRow
                      class="p-button-success p-mr-2" (click)="onRowEditInit(subject, ri)"></button>
              <button *ngIf="!editing" pButton icon="pi pi-trash" (click)="onRowDelete(subject, ri)"
                      class="p-button-danger"></button>
            </div>
            <div *ngIf="editing" class="flex flex-col">
              <button *ngIf="editing" pButton pSaveEditableRow icon="pi pi-check"
                      (click)="onRowEditSave(subject, ri)" class="p-button-success mr-2"></button>
              <button *ngIf="editing" pButton pCancelEditableRow icon="pi pi-times"
                      (click)="onRowEditCancel(subject, ri)" class="p-button-danger"></button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <p-toolbar>
      <div class="p-toolbar-group-left">
        <p-button (click)="add()" label="Add"></p-button>
      </div>
      <div class="p-toolbar-group-right">
      </div>
    </p-toolbar>

  </div>

</div>

<subject-dialog (onSave)="handleNewSubjectSave($event)" #subjectDialog [notifyTypes]="notifyTypes">
</subject-dialog>
